import { render, staticRenderFns } from "./wire_bill.vue?vue&type=template&id=524743a8&"
import script from "./wire_bill.vue?vue&type=script&lang=ts&"
export * from "./wire_bill.vue?vue&type=script&lang=ts&"
import style0 from "./wire_bill.vue?vue&type=style&index=0&id=524743a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports